const getConfig = () => ({
  apiUrl: process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : '',
  getAuthHeader() {
    const authToken = localStorage.getItem('@wkoWindowStore:authToken');
    return authToken ? `Bearer ${authToken}` : null;
  },
  getPlainAuthToken() {
    const authToken = localStorage.getItem('@wkoWindowStore:authToken');
    return authToken ? authToken.replace('JWT ', '') : null;
  },
  getHiddenColumns() {
    const hiddenColumns = localStorage.getItem('@wkoWindowStore:hiddenColumns');
    return hiddenColumns ? JSON.parse(hiddenColumns) : [];
  },
  saveHiddenColumns(hiddenColumns) {
    localStorage.setItem('@wkoWindowStore:hiddenColumns', JSON.stringify(hiddenColumns));
  },
  getCurrentPage(tableStore) {
    const page = localStorage.getItem(tableStore);
    return page ? parseInt(page, 10) : 1;
  },
  saveCurrentPage(tableStore, page) {
    localStorage.setItem(tableStore, page);
  },
});
export default getConfig();



// WEBPACK FOOTER //
// ./src/config.js